/**
 * Katalog ekranındaki yerleşim kararları — saf fonksiyonlar.
 *
 * ## Neden ayrı dosya?
 *
 * Bu iki soru ("vitrin düzeni kullanılsın mı?", "sayfalama çizilsin mi?") ekranın
 * en çok değişen, ama en az mantık içeren parçası. Bileşenin içinde koşullu
 * `className` ve `{cond && …}` olarak gömülüyken ne zaman doğru çalıştığını
 * okumak zordu; test etmek de mümkün değildi (ekranın tamamını kurmak gerekti).
 *
 * Burada durum: "4 içerik var" → bir sayfa numarası hesaplanıyor. Bileşen
 * yalnızca sonucu uygular. Kararın **gerekçesi** kodun yanında, üstünde.
 */

/**
 * Vitrin ("az içerik") düzenine geçilecek azami içerik sayısı.
 *
 * Düzen, kartların kapsayıcıya sığmadan **üst sınıra** ulaşabilmesine
 * dayanır: 1300 px'lik içerik alanında `md` yoğunlukta
 * 4 × 280 px + 3 × 20 px boşluk = 1180 px sığar, 5 kart sığmaz.
 *
 * Sınır büyütülürse kartlar sessizce daralır ve düzen, zaten var olan normal
 * ızgarayla **aynı** sonucu verir; ayrı bir muamele gereksizleşir.
 */
export const FEW_ITEMS_LIMIT = 4;

/**
 * Az içerikli kütüphanede kartlar vitrine çıkar mı?
 *
 * `auto-fill` sütunları doldurulmadan da yer ayırtır: 1600 px'lik alanda
 * `md` yoğunluk 6 sütun üretir, 2 içerik 4 boş sütun bırakır ve kartlar
 * 145 px'e düşer. Vitrin düzeni sütun sayısını içerik sayısına eşitler.
 *
 * Boş kütüphanede `false`: gösterilecek kart yok, boş bir ızgara çizmenin
 * anlamı olmaz (zaten `LibraryEmpty` basılıyor).
 */
export function usesShowcaseGrid(totalItems: number): boolean {
  return totalItems > 0 && totalItems <= FEW_ITEMS_LIMIT;
}

/**
 * Vitrin düzeninde sütun sayısı.
 *
 * Her kart kendi sütununda; en az 1 (CSS `repeat()` sıfır sütun kabul etmez).
 */
export function showcaseColumns(totalItems: number): number {
  return Math.max(1, totalItems);
}

/**
 * Sayfalama çubuğu çizilmeli mi?
 *
 * Tek sayfalı kütüphanede iki düğme de pasif hâlde "1–2 / 2" yazıyordu:
 * kullanıcı hiçbir yere gidemeyen bir kontrol görüyor. Tek sayfada gereken
 * tek bilgi zaten bölüm başlığındaki "N içerik" rozetinde var.
 */
export function showsPager(totalItems: number, pageSize: number): boolean {
  return totalItems > pageSize;
}
